import React from "react";

function ToggleButton({ checked, onToggle, disabled = false }) {
  return (
    <button
      type="button"
      className={`new-merchant-information__switch ${checked ? "is-on" : ""}`}
      aria-pressed={checked}
      disabled={disabled}
      onClick={onToggle}
    >
      <span className="new-merchant-information__switch-track">
        <span className="new-merchant-information__switch-thumb" />
      </span>
      <span className="new-merchant-information__switch-label">
        {checked ? "On" : "Off"}
      </span>
    </button>
  );
}

function RadioChoice({
  id,
  name,
  label,
  checked,
  disabled = false,
  onChange,
}) {
  return (
    <label className={`new-merchant-information__radio ${disabled ? "is-disabled" : ""}`}>
      <input
        type="radio"
        id={id}
        name={name}
        checked={checked}
        disabled={disabled}
        onChange={onChange}
      />
      <span>{label}</span>
    </label>
  );
}

function PaymentOptionCard({
  title,
  description,
  children,
}) {
  return (
    <div className="new-merchant-information__payment-card">
      <div className="new-merchant-information__payment-card-head">
        <div>
          <h4>{title}</h4>
          {description ? <p>{description}</p> : null}
        </div>
      </div>
      {children}
    </div>
  );
}

function RequestToPayCard({
  currency,
  config,
  mdr,
  setData,
}) {
  const configKey = `PaymentConfig${currency}`;
  const isMainEnabled =
    config?.IsCashPaymentAtBOBEnabled || config?.IsPaymentByCardEnabled;
  const radioThreshold = currency === "USD" ? 4 : 5;

  const handleMainToggleChange = () => {
    const nextValue = !isMainEnabled;
    setData((current) => ({
      ...current,
      [configKey]: {
        ...current[configKey],
        IsCashPaymentAtBOBEnabled: nextValue,
        IsPaymentByCardEnabled: nextValue,
        changed: true,
      },
    }));
  };

  const handleSubToggleChange = (field) => {
    setData((current) => ({
      ...current,
      [configKey]: {
        ...current[configKey],
        [field]: !current[configKey]?.[field],
        changed: true,
      },
    }));
  };

  const handleRadioChange = (onCustomer) => {
    setData((current) => ({
      ...current,
      [configKey]: {
        ...current[configKey],
        OnCustomer: onCustomer,
        changed: true,
      },
    }));
  };

  return (
    <PaymentOptionCard
      title={`${currency} Request to Pay`}
      description="Sending a remote link for card payments."
    >
               {Number(mdr) <= radioThreshold ? (
            <div className="new-merchant-information__radio-group">
              <RadioChoice
                id={`merchant-${currency}`}
                name={`merchant-information-${currency}`}
                label="On Merchant"
                checked={!config?.OnCustomer}
                disabled={!config?.IsPaymentByCardEnabled}
                onChange={() => handleRadioChange(false)}
              />
              <RadioChoice
                id={`customer-${currency}`}
                name={`merchant-information-${currency}`}
                label="On Customer"
                checked={Boolean(config?.OnCustomer)}
                disabled={!config?.IsPaymentByCardEnabled}
                onChange={() => handleRadioChange(true)}
              />
            </div>
          ) : null}
      <div className="new-merchant-information__payment-row is-main-toggle">
        <div>
          <strong>Enable payment collection methods</strong>
          <p>Switch both settlement methods on or off together.</p>
        </div>
        <ToggleButton checked={isMainEnabled} onToggle={handleMainToggleChange} />
      </div>

      {isMainEnabled ? (
        <div className="new-merchant-information__payment-body">
          <div className="new-merchant-information__payment-row">
            <div>
              <strong>Cash Payments at BOB finance</strong>
              <p>{config?.CashPaymentAtBOBAdditionalFees}% additional fees</p>
            </div>
            <ToggleButton
              checked={config?.IsCashPaymentAtBOBEnabled}
              onToggle={() => handleSubToggleChange("IsCashPaymentAtBOBEnabled")}
            />
          </div>

          <div className="new-merchant-information__payment-row">
            <div>
              <strong>Payment by Card</strong>
              <p>{config?.PaymentByCardAdditionalFees}% additional fees</p>
            </div>
            <ToggleButton
              checked={config?.IsPaymentByCardEnabled}
              onToggle={() => handleSubToggleChange("IsPaymentByCardEnabled")}
            />
          </div>

 
        </div>
      ) : null}
    </PaymentOptionCard>
  );
}

function OnlinePaymentCard({
  currency,
  config,
  setData,
}) {
  const configKey = `PaymentConfig${currency}`;

  const handleRadioChange = (onCustomer) => {
    setData((current) => ({
      ...current,
      [configKey]: {
        ...current[configKey],
        OnCustomer: onCustomer,
        OnlinePaymentByCardOnCustomer: onCustomer,
        changed: true,
      },
    }));
  };

  return (
    <PaymentOptionCard
      title={` Online Payment by Card`}
      description={`${
        config?.OnlinePaymentByCardAdditionalFees ?? 0
      }% additional card processing fees.`}
    >
      <div className="new-merchant-information__radio-group">
        <RadioChoice
          id={`online-merchant-${currency}`}
          name={`merchant-information-online-${currency}`}
          label="On Merchant"
          checked={!config?.OnlinePaymentByCardOnCustomer}
          onChange={() => handleRadioChange(false)}
        />
        <RadioChoice
          id={`online-customer-${currency}`}
          name={`merchant-information-online-${currency}`}
          label="On Customer"
          checked={Boolean(config?.OnlinePaymentByCardOnCustomer)}
          onChange={() => handleRadioChange(true)}
        />
      </div>
    </PaymentOptionCard>
  );
}

export default function PaymentFeesOptions({
  data,
  setData,
}) {
  return (
    <section className="new-merchant-information__section-card">
      <div className="new-merchant-information__section-head">
        <div>
          {/* <span className="new-merchant-information__eyebrow">Fees & Payments</span> */}
          <h3>Payment Fees</h3>
          {/* <p>
            Suyool Merchant Discount Rate (MDR) is set at{" "}
            <strong>{data?.MDR ?? 0}%</strong>.
          </p> */}
        </div>
      </div>

      <div className="new-merchant-information__payment-stack">
        {data?.PaymentConfigUSD?.IsOnlinePaymentByCardEnabled ? (
          <OnlinePaymentCard
            currency="USD"
            config={data.PaymentConfigUSD}
            setData={setData}
          />
        ) : null}

        {/* {data?.PaymentConfigLBP?.IsOnlinePaymentByCardEnabled ? (
          <OnlinePaymentCard
            currency="LBP"
            config={data.PaymentConfigLBP}
            setData={setData}
          />
        ) : null} */}

        <RequestToPayCard
          currency="USD"
          config={data?.PaymentConfigUSD}
          mdr={data?.MDR}
          setData={setData}
        />

        <RequestToPayCard
          currency="LBP"
          config={data?.PaymentConfigLBP}
          mdr={data?.MDR}
          setData={setData}
        />
      </div>
    </section>
  );
}
